<script setup lang="ts">
import type { PreparedAuctionItem } from '@autobid/ui/types/components/AuctionsData'
import CommonLink from '@autobid/ui/components/common/Link.vue'
import { inject } from 'vue'
import CatalogPopper from '../../shared/CatalogPopper.vue'

import AuctionListItemInfoElement from './AuctionListItemInfoElement.vue'

const auction = inject<PreparedAuctionItem>('auction')
</script>

<template>
  <CatalogPopper
    v-if="auction"
    :app-id="auction.appId"
    :catalog="auction.catalog"
    :restrictions="auction.restrictions"
    :stage="auction.stage"
    :type="auction.type"
  >
    <AuctionListItemInfoElement icon="mdi:download-box">
      <CommonLink
        tabindex="0"
        role="button"
        underline
        class="cursor-pointer text-sm capitalize"
      >
        {{ $t('auction-list.catalog') }}
      </CommonLink>
    </AuctionListItemInfoElement>
  </CatalogPopper>
</template>
